import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Translation, TranslocoLoader} from '@jsverse/transloco';
import {Observable} from 'rxjs';

@Injectable()
export class TranslocoHttpLoaderService implements TranslocoLoader {

  constructor(private readonly _httpClient: HttpClient) {
  }

  public getTranslation(lang: string): Observable<Translation> {
    return this._httpClient.get<Translation>(`./assets/i18n/${lang}.json`);
  }
}
